import { useMutation } from '@tanstack/react-query';

import { PricingPlan } from 'src/features/pricingPlan/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/pricing/pricing-plan/:id/create-version/`;

type MutationFnType = typeof mutationFn;

type DTO = {
    id: string;
    parkingId: string;
};

const mutationFn = ({ id,parkingId, ...data }: DTO): Promise<PricingPlan> => {
    return axios.post(formatResourcePath(RESOURCE, { id, parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreatePricingPlanVersion };
